<micro-lookup domain="auth" obj="credentials" url="/credentials" [key]="credentialId" [link]="link"></micro-lookup>
